module.exports = __webpack_public_path__ + "img/zhuanpan-zhizhen.c35477de.png";